import { CognitoUserPool } from "amazon-cognito-identity-js";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import config from "../cognito.json";

const awsRegion = "eu-central-1";
const identityPoolId = config.aws_identity_pool_id;

export const userPool = new CognitoUserPool({
  UserPoolId: config.aws_user_pools_id,
  ClientId: config.aws_user_pools_web_client_id,
});

export function decodeJWT(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export async function logoutServer() {
    const csrfToken = localStorage.getItem("csrfToken");
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": csrfToken,
    };

    try {
        const logoutResponse = await fetch(
            `${import.meta.env.VITE_APP_SERVER_URI}/${import.meta.env.VITE_APP_AUTH_SERVICE_API_VERSION
            }/auth/logout`,
            { method: "POST", credentials: "include", headers }
        );

        if (logoutResponse.status === 400) {
            console.error("Logout failed: Bad request");
        } else if (logoutResponse.status === 500) {
            console.error("Logout failed: Internal server error");
        } else if (logoutResponse.ok) {
            console.log("Logout successful");
        } else {
            const error = await logoutResponse.json();
            console.error("Logout failed:", error);
        }
    } catch (error) {
        console.error("Logout error:", error);
    }
};

export async function getPreSignedUrl(url, idToken) {
    try {
        const { hostname, pathname } = new URL(url);
        const bucketName = hostname.split(".")[0];
        const fileName = pathname.substring(1);

        const s3Client = new S3Client({
            region: awsRegion,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: awsRegion },
                identityPoolId,
                logins: {
                    [`cognito-idp.${awsRegion}.amazonaws.com/${config.aws_user_pools_id}`]: idToken,
                },
            }),
        });

        const command = new GetObjectCommand({ Bucket: bucketName, Key: fileName });
        return await getSignedUrl(s3Client, command, { expiresIn: 60 });
    } catch (err) {
        console.error("Error generating signed URL:", err);
        throw err;
    }
}
